
import { supabase } from "@/integrations/supabase/client";
import { dbUpdate } from "@/integrations/supabase/helpers";

export const useCreateOrUpdateProfile = () => {
  const createOrUpdateProfile = async (userId: string, profileData: { display_name: string, email: string }) => {
    try {
      console.log("Creating/updating profile with data:", profileData);
      console.log("User ID for profile creation:", userId);
      
      // Wait a bit to ensure auth state is fully settled
      await new Promise(resolve => setTimeout(resolve, 100));
      
      try {
        const { data, error } = await supabase.rpc('create_or_update_profile', {
          user_id: userId,
          user_email: profileData.email,
          user_display_name: profileData.display_name
        });
        
        if (error) {
          console.error("Error from create_or_update_profile RPC:", error);
          throw error;
        }
        
        console.log("Profile created/updated successfully via RPC:", data);
        return;
      } catch (rpcError) {
        console.warn("RPC failed, attempting direct upsert:", rpcError);
        
        // Check current session before attempting direct upsert
        const { data: session } = await supabase.auth.getSession();
        console.log("Current session during profile creation:", {
          hasSession: !!session.session,
          sessionUserId: session.session?.user?.id,
          targetUserId: userId
        });
        
        // For direct upsert, ensure we're using a non-optional id
        const updateData = {
          id: userId,
          email: profileData.email,
          display_name: profileData.display_name,
          updated_at: new Date().toISOString()
        };
        
        console.log("Attempting direct upsert with data:", updateData);
        
        const { error: upsertError } = await supabase
          .from('profiles')
          .upsert(updateData, { onConflict: 'id' });
        
        if (upsertError) {
          console.error("Error from direct profile upsert:", upsertError);
          console.error("Upsert error details:", {
            code: upsertError.code,
            message: upsertError.message,
            details: upsertError.details,
            hint: upsertError.hint
          });
          throw upsertError;
        }
        
        console.log("Profile created/updated successfully via direct upsert");
      }
    } catch (error) {
      console.error("Error in createOrUpdateProfile:", error);
      throw error; // Re-throw to prevent silent failures
    }
  };

  return { createOrUpdateProfile };
};
